import { SF_LOGOUT_IFRAME } from "../constant/Constants";

export const iframe = () => {
    const iframe = document.createElement("iframe");
    iframe.src = SF_LOGOUT_IFRAME;
    iframe.id = "myHiddenIframe";
    iframe.style.display = "none"; // Or use width/height = 0
    document.body.appendChild(iframe);
}